import { render, staticRenderFns } from "./must-choose-practice.vue?vue&type=template&id=aba1c830"
import script from "./must-choose-practice.vue?vue&type=script&lang=js"
export * from "./must-choose-practice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports